
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vvxn7_10f63_9",
  "grid": "awsui_grid_vvxn7_10f63_41",
  "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_10f63_47",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_10f63_51",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_10f63_59",
  "grid-columns-1": "awsui_grid-columns-1_vvxn7_10f63_62",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_10f63_62",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_10f63_65",
  "grid-columns-2": "awsui_grid-columns-2_vvxn7_10f63_68",
  "grid-columns-3": "awsui_grid-columns-3_vvxn7_10f63_74",
  "grid-columns-4": "awsui_grid-columns-4_vvxn7_10f63_80",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_10f63_96",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_10f63_129"
};
  